import { Action } from 'redux'
import { ISettingsFormValues } from '../../../containers/Form/Settings/SettingsForm'
import { ISettings } from '../../../models/Object'
import { UserSettingsActions } from '../../../reducers/userObject/actionNames'

export const requestUpdateSettings = (
  data: ISettingsFormValues,
): IRequestUpdateSettings => ({
  data,
  type: UserSettingsActions.RequestUpdateForUserSettings,
})

export interface IRequestUpdateSettings
  extends Action<UserSettingsActions.RequestUpdateForUserSettings> {
  data: ISettingsFormValues
}

export const requestSettingsAccepted = (
  settings: ISettings,
): IUpdateForUserSettingsAccepted => ({
  settings,
  type: UserSettingsActions.SettingsUpdateAccepted,
})

export interface IUpdateForUserSettingsAccepted
  extends Action<UserSettingsActions.SettingsUpdateAccepted> {
  settings: ISettings
}

export const requestSettingsRejected = (
  errMessage: string,
): IUpdateForUserSettingsRejected => ({
  errMessage,
  type: UserSettingsActions.SettingsUpdateRejected,
})

export interface IUpdateForUserSettingsRejected
  extends Action<UserSettingsActions.SettingsUpdateRejected> {
  errMessage: string
}
